export const SET_TOGGLE_SHOULD_REFETCH = 'SET_TOGGLE_SHOULD_REFETCH'

export const setToggleShouldRefetch = (payload) => ({
  type: SET_TOGGLE_SHOULD_REFETCH,
  payload,
})
